import { SET_DIALOG_VISIBLE } from '../mutation-types'

const state = {
  isVisible: false
}

const getters = {
  isVisible: state => state.isVisible
}

const mutations = {
  [SET_DIALOG_VISIBLE] (state, isVisible) {
    state.isVisible = isVisible
  }
}

const actions = {
  async setVisible ({ commit }, isVisible) {
    commit('SET_DIALOG_VISIBLE', isVisible)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/dialog.js